import { createStyles } from 'antd-style';

export const useStyles = createStyles(({ token, css, responsive }) => ({
  skuItem: css`
    display: block;
    padding: 10px 0px 10px 10px;
    // 每行第一个，不添加 padding
    &.first {
      padding-left: 0;
    }
    .ant-card-body {
      padding: 0;
    }
  `,
  skuItemTitle: css`
    padding: 8px 12px 7px;
    font-size: 14px;
    font-weight: 500;
  `,
  skuItemTitleText: css`
    white-space: pre-wrap;
    display: flex;
    align-items: center;
  `,
  skuItemImg: css`
    /* border-top: 1px solid ${token.colorBorderSecondary}; */
    padding: 0 0;
    background-position: center center;
    background-repeat: no-repeat;
    height: 150px;
  `,
  skuItemBrief: css`
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    padding: 8px 12px;
    /* border-top: 1px solid ${token.colorBorderSecondary}; */
    color: ${token.colorTextSecondary};
    .ant-badge.ant-badge-status .ant-badge-status-text {
      margin-left: ${token.marginXXS}px;
    }
  `,
}));
